<template>
  <b-modal
    size="lg"
    hide-footer
    v-model="show"
    title="Edição da Configuração"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div>
            <span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-row>
        <b-col cols="12">
          <b-form-group>
            <lg-form-date
              id="inicio-periodo"
              v-model="form.dataInicio"
              required
              placeholder="Selecione a data de início do período"
              label="Data Início do Período:"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <lg-form-date
              id="termino-periodo"
              v-model="form.dataTermino"
              required
              placeholder="Selecione a data de término do período"
              label="Data Término do Período:"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <LgFinderPageUnidadeAdministrativa
              :podeApagarDepartamento="false"
              v-model="form.unidadeAdministrativa"
              label="U.A. Responsável pelo Inventário Anual:"
              required
              @onselect="handleSelectUnidadeAdministrativa"
            />
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import ResourceService from "@/core/api/ResourceService";

export default {
  components: {
    LgFormDate,
    LgFinderPageUnidadeAdministrativa,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        dataInicio: null,
        dataTermino: null,
        unidadeAdministrativa: null,
      },
    };
  },
  methods: {
    handleSelectUnidadeAdministrativa(unidade) {
      this.form.unidadeAdministrativa = unidade;
    },
    async salvar() {
      if (!this.form.dataInicio || !this.form.dataTermino || !this.form.unidadeAdministrativa) {
        this.$bvToast.toast("Preencha todos os campos obrigatórios", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const valorPropriedade = [
        this.form.dataInicio,
        this.form.dataTermino,
        this.form.unidadeAdministrativa.id
      ].join(";");

      const payload = {
        id: this.configuracao.id,
        valorPropriedade,
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
    async carregarDadosIniciais() {
      if (this.configuracao.valorPropriedade) {
        const valores = this.configuracao.valorPropriedade.split(";");
        this.form.dataInicio = valores[0] || null;
        this.form.dataTermino = valores[1] || null;
        this.form.unidadeAdministrativa = (await this.$service.findById(parseInt(valores[2], 10))).data;
      }
    },
  },
  beforeMount(){
    this.$service = new ResourceService(`/api/departamentos`);
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
